import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import api from "@/lib/api";
import { Input } from "@/components/ui/input";
import { ChevronDown, ChevronRight, Search } from "lucide-react";

export default function Agenda() {
  const [data, setData] = useState(null);
  const [abertas, setAbertas] = useState({}); // {data: bool} — fechado por padrão
  const [busca, setBusca] = useState("");

  useEffect(() => { api.get("/montador/agenda?dias=30").then(r => setData(r.data)); }, []);

  if (!data) return <div className="p-12 text-muted-foreground">Carregando…</div>;

  const q = busca.trim().toLowerCase();
  const filtrados = q
    ? data.servicos.filter(s =>
        [s.cliente_nome, s.os_numero, s.pim_code, s.codigo_produto, s.produto]
          .some(v => String(v || "").toLowerCase().includes(q)))
    : data.servicos;

  const porData = {};
  filtrados.forEach(s => {
    const d = s.data_confirmada;
    if (!porData[d]) porData[d] = [];
    porData[d].push(s);
  });

  return (
    <>
      <div className="max-w-4xl mx-auto p-6 space-y-6">
        {/* Capacidade próxima */}
        <div className="border border-border bg-white p-5">
          <div className="label-cap mb-3">Capacidade próximas 2 semanas</div>
          <div className="grid grid-cols-7 gap-1">
            {data.capacidade.map((c) => {
              const d = new Date(c.data + "T00:00:00");
              const dow = d.toLocaleDateString("pt-BR", { weekday: "short" });
              const dia = d.getDate();
              const cheio = c.restantes === 0;
              const ocupacao = (c.agendadas / c.limite) * 100;
              return (
                <div key={c.data}
                  className={`p-2 text-center border ${cheio ? "border-[#E60000] bg-[#E60000]/5" : "border-border bg-white"}`}
                  data-testid={`cap-${c.data}`}>
                  <div className="label-cap text-[9px]">{dow}</div>
                  <div className="font-heading font-bold text-lg">{dia}</div>
                  <div className={`text-[10px] font-mono ${cheio ? "text-[#E60000]" : "text-muted-foreground"}`}>
                    {c.agendadas}/{c.limite}
                  </div>
                  <div className="h-1 bg-[#F4F4F5] mt-1">
                    <div className="h-1 brand-bg" style={{ width: `${Math.min(100, ocupacao)}%` }} />
                  </div>
                </div>
              );
            })}
          </div>
          <div className="text-[10px] text-muted-foreground mt-2">
            Limite: 10 montagens em janela rolante de 7 dias.
          </div>
        </div>

        {/* Busca */}
        <div className="relative">
          <Search size={15} className="absolute left-3 top-1/2 -translate-y-1/2 text-muted-foreground" />
          <Input value={busca} onChange={e => setBusca(e.target.value)}
            placeholder="Buscar cliente por nome, OS ou código…"
            className="pl-9 bg-white" data-testid="agenda-busca" />
        </div>

        {/* Lista por data — fechada por padrão, clique para abrir */}
        <div>
          <div className="label-cap mb-3">Próximas montagens ({filtrados.length})</div>
          {filtrados.length === 0 && (
            <div className="border border-dashed border-border bg-white p-12 text-center text-muted-foreground">
              {q ? "Nada encontrado para esta busca." : "Sem montagens agendadas."}
            </div>
          )}
          {Object.entries(porData).sort().map(([d, lista]) => {
            const aberta = !!abertas[d] || !!q; // busca ativa expande automaticamente
            return (
              <div key={d} className="mb-2 border border-border bg-white">
                <button onClick={() => setAbertas(a => ({ ...a, [d]: !a[d] }))}
                  className="w-full flex items-center justify-between p-4 hover:bg-secondary text-left"
                  data-testid={`ag-dia-${d}`}>
                  <span className="font-heading font-bold text-base capitalize">
                    {new Date(d + "T00:00:00").toLocaleDateString("pt-BR", { weekday: "long", day: "2-digit", month: "long" })}
                  </span>
                  <span className="flex items-center gap-2 text-xs text-muted-foreground">
                    {lista.length} montagem(ns) {aberta ? <ChevronDown size={16} /> : <ChevronRight size={16} />}
                  </span>
                </button>
                {aberta && (
                  <div className="border-t border-border p-3 space-y-2">
                    {lista.map((s) => (
                      <Link key={s.id} to={`/montador/servico/${s.id}`}
                        className="block border border-border bg-white p-4 hover:bg-secondary"
                        data-testid={`ag-${s.id}`}>
                        <div className="flex justify-between items-start">
                          <div>
                            <strong>{s.cliente_nome}</strong>
                            <div className="text-xs text-muted-foreground">{s.cliente_endereco} · {s.cliente_cidade}</div>
                            <div className="text-[10px] text-muted-foreground mt-0.5">OS: {s.os_numero || s.pim_code}</div>
                          </div>
                          <span className="px-2 py-0.5 bg-secondary text-[10px] uppercase tracking-wider">{s.tipo}</span>
                        </div>
                        <div className="text-sm mt-2">{s.produto} ({s.quantidade})</div>
                      </Link>
                    ))}
                  </div>
                )}
              </div>
            );
          })}
        </div>
      </div>
    </>
  );
}
